import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import * as BsIcons from 'react-icons/bs';
import ScreenLoader from '../../../components/ScreenLoader';
import EventTable from '../../../components/ViewMatch/EventTable';
import actions from '../../../redux/actions';
import NavbarSidebarWrapper from '../../../components/navbarSidebarWrapper';
import TableWrapper from './TableWrapper';
import { notifyError, notifySuccess } from '../../../components/ToastContext';

const SMBookMarket = () => {

  const smMarketListResult = useSelector((state) => state.SM.SMMarketList.Result);
  const safeMarketList = Array.isArray(smMarketListResult) ? smMarketListResult : [];

  const [action, setAction] = useState(true);
  const [loader, setLoader] = useState(false);
  const [data, setData] = useState({
    sportsId: '4',
    value: null,
    skipRec: 0,
    take: 10,
    type: 0
  })

  const [dataList, setDataList] = useState([]);

  const handleData = (e) => {
    let { name, value } = e.target;
    setData({ ...data, [name]: value })
  }

  const handleOpenMarketList = async () => {
    setLoader(true)
    let res = await actions.GetSMMarketList(false);
    if (res) {
      setLoader(false)
    }
    setDataList(res);
  }

  const handleCompletedMarketList = async () => {
    setLoader(true)
    let res = await actions.GetSMMarketList(true);
    if (res) {
      setLoader(false)
    }
    setDataList(res);
  }
  useEffect(() => {
    handleOpenMarketList()
  }, [])

  const handleDeleteAction = async (MarketId) => {
    if (window.confirm("Are you sure you want to RollBack this result?")) {
      try {
        const response = await actions.SetSMDeleteResult(MarketId);
        if (response?.data?.Status) {
          notifySuccess(response.data.Result);
          await actions.GetSMMarketList(false);
        } else {
          notifyError(response?.data?.Result || "Failed to RollBack result.");
        }
      } catch (error) {
        notifyError("Something went wrong.");
      }
    }
  };

  return (
    <NavbarSidebarWrapper>
      <div>
        <div className="content-header-btn mb-2">
          Market Game
        </div>
        <>
          <ul className="nav nav-tabs">
            <li className="nav-item">
              <a className="nav-link active" data-toggle="tab" href="#tab2" onClick={() => handleOpenMarketList()}>
                Open
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link" data-toggle="tab" href="#tab4" onClick={() => handleCompletedMarketList()}>
                Completed
              </a>
            </li>
          </ul>
          {loader ? <ScreenLoader /> :
            <div className="tab-content">
              <form>
                <div className="row">
                  <div className="col-6 col-md-3">
                    <div className="form-group">
                      {/* <label htmlFor="textbox2">Search</label>
                        <input type="text" className='form-control' value={data.value} name="txtvalue" onChange={handleMatchname} /> */}
                    </div>
                  </div>
                </div>

              </form>
              <div className="tab-pane fade show active" id="tab2">
                <TableWrapper  data={safeMarketList} showAction={action} handleDeleteAction={handleDeleteAction} handleData={handleData} />
              </div>
              <div className="tab-pane fade" id="tab4">
                <TableWrapper  data={safeMarketList} showAction={action} handleDeleteAction={handleDeleteAction} handleData={handleData} />
              </div>
            </div>}
        </>
      </div>
    </NavbarSidebarWrapper>
  )
};

export default SMBookMarket;